import React,{useId} from 'react';
import {CircleHelp} from 'lucide-react';

export default function OverviewHoverHelp({label,children}) {
  const id=useId();
  return <span className="overview-hover-help"><button type="button" aria-label={label} aria-describedby={id}><CircleHelp size={15}/></button><span id={id} role="tooltip">{children}</span></span>;
}
